import React from "react";
import { Modal } from "react-bootstrap";
import VisualEditor from "./VisualEditor";

const primaryBtnCls =
  "inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
const secondaryBtnCls =
  "inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700";

const VisualEditorModal = ({
  changeItem,
  fieldList = [],
  idkey,
  onClose,
  value,
}) => (
  <Modal
    centered
    enforceFocus={false}
    onHide={onClose}
    scrollable
    show={idkey !== null && idkey !== undefined}
    size="xl"
    contentClassName="overflow-hidden rounded-lg bg-zinc-50 shadow-xl ring-1 ring-zinc-200 dark:bg-zinc-900 dark:text-zinc-100 dark:ring-zinc-700"
  >
    <Modal.Header className="flex shrink-0 items-start justify-between border-b-0 px-4 pt-4 sm:px-6 sm:pt-6">
      <Modal.Title className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
        Visual Editor
      </Modal.Title>
      <button
        type="button"
        onClick={onClose}
        className="rounded-md p-1 text-zinc-500 hover:bg-zinc-100 hover:text-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-200"
        aria-label="Close"
      >
        &times;
      </button>
    </Modal.Header>
    <Modal.Body className="min-h-0 px-4 sm:px-6">
      {fieldList.length > 0 &&
        (idkey?.toLowerCase().includes("email") ||
          idkey === "confirmationCopy") && (
          <div className="mb-4 text-sm text-zinc-700 dark:text-zinc-300">
            <label className="font-medium">Available Fields:</label>
            <br />
            {fieldList.map((field, index) => (
              <span key={field}>
                {`{${field}}`}
                {index < fieldList.length - 1 ? ", " : ""}
              </span>
            ))}
            <br />
            <br />
          </div>
        )}
      <div className="min-w-0">
        <VisualEditor idkey={idkey} value={value} changeItem={changeItem} />
      </div>
    </Modal.Body>
    <Modal.Footer className="flex shrink-0 flex-wrap justify-end gap-2 border-t border-zinc-200 px-4 py-4 sm:px-6 dark:border-zinc-700">
      <button type="button" className={secondaryBtnCls} onClick={onClose}>
        Close
      </button>
      <button type="button" className={primaryBtnCls} onClick={onClose}>
        Update
      </button>
    </Modal.Footer>
  </Modal>
);

export default VisualEditorModal;
